import type { ElementRef } from '@angular/core';
import { Component, ViewChild } from '@angular/core';

import type { RcrStickyFooterConfig } from '../../rcr-exchange/shared/sticky-toolbar/rcr-exchange-footer.component';

@Component({
  standalone: false,
  selector: 'invd-footer-button',
  templateUrl: './footer-button.html',
  styleUrls: ['./footer-button.scss'],
})
export class FooterButtonComponent {
  public config: RcrStickyFooterConfig;
  @ViewChild('exchangeCommitOrSubmitButtonClick') exchangeCommitOrSubmitButtonClick: ElementRef;

  public onSelect(value: any): void {
    if (this.config.change) {
      this.config.change(value);
    }
  }
  public onClick(value: any): void {
    if (
      !this.exchangeCommitOrSubmitButtonClick.nativeElement.innerText
        .toUpperCase()
        .includes('CANCEL')
    ) {
      this.exchangeCommitOrSubmitButtonClick.nativeElement.disabled = true;
    }
    if (this.config.click) {
      this.config.click(value);
    }
  }
}
